import mitt from "mitt";

export const toastBus = mitt();